import { Dialog } from '@cimplico/components';
import { toastNotification } from '../../components/toast/Toast';
import { useUpdateChecklistItems } from '../../queries/use-update-checklist-items';

type RemoveFromCategoryConfirmProps = {
    checklistId: string;
    checklistItemIds: string[];
    isOpen: boolean;
    onClose: () => void;
    onRemove: () => void;
};

function RemoveFromCategoryConfirm({
    checklistId,
    checklistItemIds,
    isOpen,
    onClose,
    onRemove,
}: RemoveFromCategoryConfirmProps): JSX.Element {
    const updateChecklistItemsQuery = useUpdateChecklistItems(checklistId);

    function remove(): void {
        updateChecklistItemsQuery.mutate(
            checklistItemIds.map((i) => ({
                id: i,
                fields: {
                    categoryId: null,
                },
            })),
            {
                onSuccess: () => {
                    onRemove();
                    toastNotification(
                        'success',
                        `${checklistItemIds.length} ${checklistItemIds.length === 1 ? 'item' : 'items'} removed from ${
                            checklistItemIds.length === 1 ? 'category' : 'categories'
                        }!`
                    );
                },
            }
        );
    }

    return (
        <Dialog
            type="error"
            title="Remove items from categories"
            description={`Do you want to remove the selected ${checklistItemIds.length === 1 ? 'item' : 'items'} from ${
                checklistItemIds.length === 1 ? 'its category' : 'their respective categories'
            }?`}
            isOpen={isOpen}
            primaryAction="Remove"
            secondaryAction="Cancel"
            onClose={onClose}
            onSecondaryActionClick={onClose}
            onPrimaryActionClick={remove}
            isLoading={updateChecklistItemsQuery.isLoading}
        />
    );
}
export default RemoveFromCategoryConfirm;
